import _ from "lodash"
import React from "react"
import Chart from "react-google-charts"

const SELECTED_STYLE = "color: #007bff"
const UNSELECTED_STYLE = "color: #d5dbdb"

const options = {
  bar: { groupWidth: "90%" },
  chartArea: {
    width: "100%",
  },
  legend: { position: "none" },
  focusTarget: "category",
  tooltip: {
    isHtml: true,
    showColorCode: false,
  },
  hAxis: {
    textPosition: "none",
    baselineColor: "transparent",
    gridlines: {
      color: "transparent",
    },
  },
  vAxis: {
    baselineColor: "transparent",
    gridlines: {
      color: "transparent",
    },
    textPosition: "none",
  },
}

const dataSchema = [{ type: "string" }, "Values", { role: "style" }]


export class DateFacetHeuristicChart extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.getStateFromProps()
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps, this.props)) {
      this.setState(this.getStateFromProps())
    }
  }

  getStateFromProps() {
    const { availableDateFacet, fullRange, displaySelectionRange } = this.props

    const data = [dataSchema]
    for (let year = fullRange[0]; year <= fullRange[1]; year++) {
      let style = UNSELECTED_STYLE
      if (year >= displaySelectionRange[0] && year <= displaySelectionRange[1]) {
        style = SELECTED_STYLE
      }

      data.push([
        `${year}`,
        _.get(availableDateFacet.yearHeuristic, year, 0),
        style,
      ])
    }

    return {
      data,
    }
  }

  render() {
    const { data } = this.state

    return (
      <Chart
        chartType="ColumnChart"
        width="100%"
        height="75px"
        data={data}
        options={options}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/facets/components/DateFacetHeuristicChart.js